<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import {useStore} from "vuex";

const store = useStore();

const onClick = () => {
  store.dispatch('competitionV2/resetCompareCompetitors');
}

</script>

<template>
  <DefaultButton
    variant="primary-inverted"
    @click="onClick"
  >
    <span class="tw-mr-2">Clear All</span>
    <svg-vue
      icon="icons/clear-filter"
      class="tw-h-6 tw-w-6"
    />
  </DefaultButton>
</template>
